(function (Drupal, $, once) {
  'use strict';

  // This file is the only one that opens or closes the flyout, sets
  // aria-expanded on its buttons and moves focus. menu.js and sticky-header.js
  // leave the burger, sign-in and close buttons alone so the scripts never
  // fight over that state.
  const openerSelector = '#burger-menu, .header__sign-in';

  // The menu list carries tabindex="1" from its template. It is not a control,
  // so only real controls and tabindex="0" elements count as tab stops.
  const tabStopSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';

  let lastOpener = null;

  const getFlyout = () => document.getElementById('mobile-menu');

  const isShown = (el) => el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';

  const isOpen = () => {
    const flyout = getFlyout();
    return !!flyout && flyout.classList.contains('sidebar__open');
  };

  // Visible tab stops inside the flyout, in page order. Signed-in visitors
  // see a different set of links, so this runs on every key press.
  const getTabStops = () => {
    const flyout = getFlyout();
    if (!flyout) {
      return [];
    }
    return Array.prototype.filter.call(flyout.querySelectorAll(tabStopSelector), isShown);
  };

  const openFlyout = (opener) => {
    const flyout = getFlyout();
    if (!flyout) {
      return;
    }
    lastOpener = opener;
    $('html, body').addClass('sidebar--open');
    $(flyout).addClass('sidebar__open');
    $('header').addClass('fixed');
    $(openerSelector).attr('aria-expanded', 'true');
    // aria-modal goes on only while the panel is open. The closed panel is
    // still in the layout, and a modal flag there could hide the page from a
    // screen reader.
    flyout.setAttribute('aria-modal', 'true');

    // The class above makes the panel visible, so it can take focus now.
    const target = document.getElementById('burger-close-button') || getTabStops()[0];
    if (target) {
      target.focus({ preventScroll: true });
    }
  };

  const closeFlyout = () => {
    const flyout = getFlyout();
    $('html, body').removeClass('sidebar--open');
    $(flyout).removeClass('sidebar__open');
    $('header').removeClass('fixed');
    $(openerSelector).attr('aria-expanded', 'false');
    if (flyout) {
      flyout.removeAttribute('aria-modal');
    }

    // Focus goes back to the button that opened the panel. The burger is
    // hidden on wide screens, so fall back to whichever opener is visible.
    const target = [lastOpener].concat($(openerSelector).get()).find((el) => el && isShown(el));
    lastOpener = null;
    if (target) {
      target.focus({ preventScroll: true });
    }
  };

  Drupal.behaviors.sidebar = {
    attach: function attach(context) {
      once('sidebar-dialog', '#mobile-menu', context).forEach((flyout) => {
        flyout.setAttribute('role', 'dialog');
        flyout.setAttribute('aria-label', Drupal.t('Site menu'));
      });

      $(once('sidebar-open', openerSelector, context)).on('click', function () {
        if (isOpen()) {
          closeFlyout();
        } else {
          openFlyout(this);
        }
      });

      $(once('sidebar-close', '#burger-close-button', context)).on('click', closeFlyout);

      // The Spanish link loads MotionPoint's language chooser outside the
      // panel. Close the panel first, or aria-modal hides the chooser from
      // screen readers and the Tab loop pulls focus back into the panel.
      $(once('sidebar-language', '#mpel-mobile-language-toggle', context)).on('click', closeFlyout);

      // Escape closes the panel, and Tab and Shift+Tab cycle through its
      // controls while it is open. The listener belongs to the document, so it
      // binds on the first attach only.
      once('sidebar-keys', 'html', context).forEach(() => {
        document.addEventListener('keydown', (e) => {
          if (!isOpen()) {
            return;
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            closeFlyout();
            return;
          }
          if (e.key !== 'Tab') {
            return;
          }
          const stops = getTabStops();
          if (!stops.length) {
            return;
          }
          e.preventDefault();
          const index = stops.indexOf(document.activeElement);
          const step = e.shiftKey ? -1 : 1;
          let next;
          if (index === -1) {
            next = e.shiftKey ? stops[stops.length - 1] : stops[0];
          } else {
            next = stops[(index + step + stops.length) % stops.length];
          }
          next.focus();
        });
      });
    }
  };

})(Drupal, jQuery, once);
